import _jsx from '@babel/runtime/helpers/esm/jsx';
import RedBox from 'redbox-react';

const DevelopmentErrorDisplay=a=>{let{didCatchArgs:b}=a;const[c]=b;return/*#__PURE__*/_jsx(RedBox,{error:c,style:{message:{whiteSpace:"pre-wrap",fontWeight:"bold"}}})};DevelopmentErrorDisplay.displayName="DevelopmentErrorDisplay";

export { DevelopmentErrorDisplay as default };
